import { render } from "./contactGroup.vue?vue&type=template&id=5aede6d4&scoped=true"
import script from "./contactGroup.vue?vue&type=script&lang=ts"
export * from "./contactGroup.vue?vue&type=script&lang=ts"

import "./contactGroup.vue?vue&type=style&index=0&id=5aede6d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5aede6d4"

export default script